import React from 'react';
import { CheckCircle2, Shield, Star } from 'lucide-react';
const HERO_BULLETS = ['Broken window repair, window pane replacement, insulated glass and foggy double-pane service', 'Replace the glass only when your existing window frames are still in good condition', 'Door glass, shower glass, custom mirrors, table tops, shelves, screens and decorative glass', 'Family-owned since 2000, serving Howell, Ann Arbor, Novi and Southeast Michigan'];
export function HeroContent() {
  return <div className="lg:col-span-7 flex flex-col justify-center" data-id="element-97">
      <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-red-50 text-red-700 text-sm font-semibold mb-4 w-fit border border-red-100 anim-fade-up" style={{
      animationDelay: '0s'
    }} data-id="element-98">
        <span className="relative flex h-2 w-2" aria-hidden="true" data-id="element-99">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-100" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500" data-id="element-101" />
        </span>
        Broken or Foggy Window? Free In-Home Estimates Available
      </div>

      <div className="inline-flex flex-wrap items-center gap-x-3 gap-y-1 mb-4 text-sm text-slate-700 anim-fade-up" style={{
      animationDelay: '0.05s'
    }} aria-label="5-star reviews and trust signals" data-id="element-102">
        <span className="flex items-center gap-1 text-amber-500" aria-hidden="true" data-id="element-103">
          <Star className="w-4 h-4 fill-amber-500" data-id="element-104" />
          <Star className="w-4 h-4 fill-amber-500" data-id="element-105" />
          <Star className="w-4 h-4 fill-amber-500" data-id="element-106" />
          <Star className="w-4 h-4 fill-amber-500" data-id="element-107" />
          <Star className="w-4 h-4 fill-amber-500" data-id="element-108" />
        </span>
        <span className="sr-only" data-id="element-109">5-star rated</span>
        <span className="font-semibold text-navy-900" data-id="element-110">
          Trusted by Southeast Michigan Homeowners
        </span>
        <span aria-hidden="true" className="text-slate-300" data-id="element-111">
          ·
        </span>
        <span data-id="element-112">Free In-Home Estimates</span>
        <span aria-hidden="true" className="text-slate-300" data-id="element-113">
          ·
        </span>
        <span data-id="element-114">Family-Owned Since 2000</span>
      </div>

      <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-navy-900 leading-[1.1] mb-4 tracking-tight anim-fade-up" style={{
      animationDelay: '0.1s'
    }} data-id="element-115">
        Residential Glass Repair &{' '}
        <span className="text-brandBlue-600" data-id="element-116">
          Home Window Glass Replacement
        </span>{' '}
        in Southeast Michigan
      </h1>

      <p className="text-base sm:text-lg text-slate-600 mb-5 leading-relaxed max-w-2xl anim-fade-up" style={{
      animationDelay: '0.15s'
    }} data-id="element-117">
        Broken window glass, foggy double-pane windows, failed seals, door
        glass, shower glass, mirrors, table tops or custom home glass? Kosin’s
        Glass provides expert residential glass repair and replacement with free
        in-home estimates, competitive pricing and warranty-backed workmanship.
      </p>

      <ul className="space-y-2.5 mb-5 anim-fade-up" style={{
      animationDelay: '0.2s'
    }} data-id="element-118">
        {HERO_BULLETS.map((bullet, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-119">
            <CheckCircle2 className="w-5 h-5 text-brandBlue-600 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-120" />
            <span className="text-slate-700 text-base" data-id="element-121">{bullet}</span>
          </li>)}
      </ul>

      <div className="flex items-center gap-2 text-sm text-slate-500 bg-slate-50 p-3 rounded-lg w-fit border border-slate-100 anim-fade-up" style={{
      animationDelay: '0.25s'
    }} data-id="element-122">
        <Shield className="w-4 h-4 text-emerald-600" aria-hidden="true" data-id="element-123" />
        <span data-id="element-124">
          Your information is secure. Kosin’s Glass will never share your
          details.
        </span>
      </div>
    </div>;
}